function Xinje() {
  return (
    <>
      <div
        className="container-fluid page-header py-5  wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">Xinje</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Products</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Xinje
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8 text-center">
            <h1 className=" fw-bold mb-4 text-gradient-primary">
              Advanced Industrial Automation
              <br className="d-none d-lg-block" />
              Solutions by Xinje
            </h1>
          </div>
        </div>
      </div>

      <div className="container-fluid  bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1 order-2">
              <div className="pe-lg-5">
                {/* <span className="badge bg-danger bg-opacity-10 text-danger mb-3">
                  FEATURED PRODUCT
                </span> */}

                <div className="section-header ">
                  <h2 className="section-title text-danger fs-3 mb-3">
                    Precision Motion Control for{" "}
                    <span className="text-dark">Industrial Applications</span>
                  </h2>
                </div>
                <p className="fs-6 mb-4 fs-5">
                  Xinje's DS series servo systems deliver exceptional
                  performance with high torque, precise positioning, and stable
                  operation.
                </p>
                <ul className="list-unstyled text-muted mb-4 fs-6">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-danger me-2"></i>
                    Auto-tuning capabilities
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-danger me-2"></i>
                    Built-in position control
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-danger me-2"></i>
                    Multi-protocol communication
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 order-lg-2 order-1">
              {/* <div className="position-relative"> */}
              <img
                src={require("../assets/img/products/Xinje/Precision Motion Control for Industrial.png")}
                alt="Xinje Servo System"
                className="img-fluid rounded-3 shadow-lg w-100"
                style={{ maxHeight: "400px", objectFit: "contain" }}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* ....................... */}

      <div className="container mt-5">
        <h1 className="text-gradient-primary fw-bold fs-2 mt-1 text-center ">
          Your Trusted Source for Cutting-Edge Industrial
          <br /> Automation Solutions
        </h1>

        <p className="text-center w-100 fs-6 ">
          Xinje Technology offers comprehensive automation solutions for
          industrial applications, combining innovative technology with reliable
          performance to optimize your manufacturing processes.
        </p>
      </div>

      {/* ....................... */}
      <div className="automation-hero bg-dark text-white position-relative overflow-hidden">
        {/*  */}

        {/* Animated background elements */}
        <div className="position-absolute top-0 start-0 w-100 h-100">
          <div className="position-absolute bottom-0 end-0">
            <i className="fas fa-cog fa-spin text-muted opacity-25 fa-5x me-5 mb-5 d-none d-lg-block"></i>
            <i className="fas fa-cog fa-spin text-muted opacity-25 fa-4x me-4 mb-4 d-none d-lg-block"></i>
            <i className="fas fa-cog fa-spin text-muted opacity-25 fa-3x me-3 mb-3 d-none d-lg-block"></i>
          </div>
        </div>
      </div>

      {/* Solutions Section */}
      <div className="container  my-5">
        <div className="row g-4 justify-content-center">
          {/* PLC Systems */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4">
                <div
                  className="rounded-circle bg-danger bg-opacity-10 text-danger mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fas fa-microchip fs-3"></i>
                </div>
                <h3 className="h4 fw-bold mb-3">PLC Systems</h3>
                <p className="fs-6 mb-4">
                  Xinje's XD series PLCs offer high-speed processing with
                  extensive I/O options for precise control over your automation
                  systems.
                </p>
              </div>
            </div>
          </div>

          {/* HMI Touchscreens */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4">
                <div
                  className="rounded-circle bg-danger bg-opacity-10 text-danger mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fas fa-robot fs-3"></i>
                </div>
                <h3 className="h4 fw-bold mb-3">HMI Touchscreens</h3>
                <p className="fs-6 mb-4">
                  TouchWin series HMIs provide intuitive interfaces for
                  monitoring and controlling your industrial equipment with
                  ease.
                </p>
              </div>
            </div>
          </div>

          {/* Servo Systems */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4">
                <div
                  className="rounded-circle bg-danger bg-opacity-10 text-danger mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fas fa-gears fs-3"></i>
                </div>
                <h3 className="h4 fw-bold mb-3">Servo Systems</h3>
                <p className="fs-6 mb-4">
                  DS series servo drives and motors deliver precise positioning
                  control for demanding automation applications.
                </p>
              </div>
            </div>
          </div>

          {/* Motion Controllers */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4">
                <div
                  className="rounded-circle bg-warning bg-opacity-10 text-danger mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fas fa-robot fs-3"></i>
                </div>
                <h3 className="h4 fw-bold mb-3">Motion Controllers</h3>
                <p className="fs-6 mb-4">
                  Advanced motion control solutions for multi-axis coordination
                  in robotics and CNC applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ................. */}

      <div className="container-fluid bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Xinje/AdobeStock_342434006-1024x683.jpeg")}
                alt="Xinje Automation Systems"
                className="img-fluid rounded shadow"
              />
            </div>

            <div className="col-lg-6">
              <div className="d-flex align-items-center mb-3">
                <i className="fa-solid fa-industry me-2 fs-3 text-danger"></i>
                <p className="fs-5 fw-bold mb-0">Industrial Solutions</p>
              </div>

              <div className="section-header mb-2">
                <h2 className="section-title  fs-3 text-danger mb-2">
                  Streamline Your Manufacturing{" "}
                  <span className="text-dark">With Xinje Automation</span>
                </h2>
              </div>

              <p className="fs-6 mb-4">
                Xinje Technology offers a comprehensive range of industrial
                automation products designed to increase efficiency, reduce
                downtime, and optimize production processes. Our solutions are
                trusted by manufacturers worldwide for their reliability,
                performance, and cost-effectiveness.
              </p>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Quality Control Systems</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Data Acquisition</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Process Monitoring</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Remote Management</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-light py-5 ">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="d-flex align-items-center mb-3">
                <i className="fa-solid fa-industry me-2 fs-3 text-danger"></i>
                <p className="fs-5 fw-bold mb-0">Complete Solutions</p>
              </div>

              <div className="section-header mb-2">
                <h2 className="section-title text-danger fs-3 mb-3">
                  Enhance Your Manufacturing{" "}
                  <span className="text-dark">With Xinje Technology</span>
                </h2>
              </div>

              <p className="mb-4 fs-6">
                Our integrated automation solutions combine hardware and
                software to create seamless manufacturing systems. From
                individual components to complete factory automation, Xinje
                provides reliable products that optimize production efficiency,
                reduce downtime, and improve quality control.
              </p>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Technical Support</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>System Integration</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Training Programs</div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center me-3"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fa-solid fa-check text-white"></i>
                    </div>
                    <div>Customized Solutions</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={require("../assets/img/products/Xinje/IE_Manufacturing_Module Image.webp")}
                alt="Xinje Factory Automation"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section with Call-to-Action */}
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="position-relative">
              <img
                className="img-fluid rounded shadow"
                alt="Xinje Control Systems"
                src={require("../assets/img/products/Xinje/Advanced Industrial & Automation Solutions By.png")}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="section-header mt-3 mb-2">
              <h2 className="section-title fs-3  text-danger ">
                Advanced Industrial{" "}
                <span className="text-dark"> & Automation Solutions</span>
              </h2>
            </div>
            <h4 className="text-danger mb-3">By Xinje Technology</h4>
            <p className="fs-6 mb-4">
              Xinje Technology is a leading provider of industrial automation
              products including PLCs, HMI touchscreens, servo systems, and
              motion controllers. Our cutting-edge solutions combine
              reliability, performance, and affordability for all your
              automation needs.
            </p>
          </div>
        </div>
      </div>

      {/* Featured Products Section */}
      <div
        className="container-fluid bg-light py-5"
        style={{
          background: "linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)",
        }}
      >
        <div className="container mt-5">
          <div className="text-center  mb-5">
            <h6 className="text-uppercase fw-bold text-muted letter-spacing-2">
              OUR PRODUCTS
            </h6>
            <h1
              className="fs-2 text-gradient-primary fw-bold mb-4"
              style={{ color: "#dc3545" }}
            >
              Featured <span className="text-dark">Automation Solutions</span>
            </h1>
            <div
              className="mx-auto"
              style={{
                width: "80px",
                height: "4px",
                backgroundColor: "#dc3545",
              }}
            ></div>
          </div>

          <div className="row g-4 justify-content-center">
            {/* PLC Card */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div
                className="card h-100 border-0 shadow-lg overflow-hidden transition-all"
                style={{ borderRadius: "15px", transition: "transform 0.3s" }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={require("../assets/img/products/Xinje/images XD.jpg")}
                    className="card-img-top img-fluid"
                    alt="Xinje PLC"
                    style={{ height: "220px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="card-title fw-bold mb-0">XD Series PLCs</h5>
                  </div>

                  <p className="card-text text-muted mb-4 fs-6">
                    High-performance programmable logic controllers with
                    advanced processing capabilities.
                  </p>
                </div>
              </div>
            </div>

            {/* HMI Card */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div
                className="card h-100 border-0 shadow-lg overflow-hidden transition-all"
                style={{ borderRadius: "15px", transition: "transform 0.3s" }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={require("../assets/img/products/Xinje/touchwin-hmi-touch-panels.jpg")}
                    className="card-img-top img-fluid"
                    alt="Xinje HMI"
                    style={{ height: "220px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="card-title fw-bold mb-0">
                      TouchWin HMI Series
                    </h5>
                  </div>

                  <p className="card-text text-muted mb-4 fs-6">
                    Intuitive touch-screen interfaces for seamless machine
                    monitoring and control.
                  </p>
                </div>
              </div>
            </div>

            {/* Servo Card */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div
                className="card h-100 border-0 shadow-lg overflow-hidden transition-all"
                style={{ borderRadius: "15px", transition: "transform 0.3s" }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={require("../assets/img/products/Xinje/xinje-servo-drive.jpg")}
                    className="card-img-top img-fluid"
                    alt="Xinje Servo"
                    style={{ height: "220px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="card-title fw-bold mb-0">
                      DS Servo Systems
                    </h5>
                  </div>

                  <p className="card-text text-muted mb-4 fs-6">
                    Precision motion control with exceptional torque and
                    positioning accuracy.
                  </p>
                </div>
              </div>
            </div>

            {/* VFD Card */}
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div
                className="card h-100 border-0 shadow-lg overflow-hidden transition-all"
                style={{ borderRadius: "15px", transition: "transform 0.3s" }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={require("../assets/img/products/Xinje/images AC.jpg")}
                    className="card-img-top img-fluid"
                    alt="Xinje VFD"
                    style={{ height: "220px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="card-title fw-bold mb-0">
                      AC Drive Inverters
                    </h5>
                  </div>

                  <p className="card-text text-muted mb-4 fs-6">
                    Energy-efficient motor control with comprehensive protection
                    features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Feature Highlights */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="position-relative">
                <img
                  src={require("../assets/img/products/Xinje/siemens-sinamics-s210-servo-drive-systems.jpg")}
                  alt="Xinje Servo System"
                  className="img-fluid rounded shadow-lg"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <h6 className="text-dark fw-bold">PREMIUM TECHNOLOGY</h6>

              <div className="section-header mb-2">
                <h2 className="section-title fs-2 text-danger mb-3">
                  Next-Generation{" "}
                  <span className="text-dark">Servo Systems</span>
                </h2>
              </div>
              <p className="mb-4 fs-6">
                Xinje's DS series servo systems deliver exceptional performance
                with high torque, precise positioning, and stable operation. Our
                advanced motion control solutions are designed for demanding
                industrial applications requiring accuracy and reliability.
              </p>

              <div className="row g-4 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div
                        className=" rounded-circle  d-flex align-items-center justify-content-center"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <i className="fa-solid fa-gauge-high text-dark fs-4"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-0">High-Speed Response</h5>
                      <p className="mb-0 text-muted">
                        2000Hz frequency response
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div
                        className=" rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <i className="fa-solid fa-microchip text-dark fs-4"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-0">Auto-Tuning</h5>
                      <p className="mb-0 text-muted">
                        Smart parameter adjustment
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div
                        className=" rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <i className="fa-solid fa-network-wired text-dark fs-4"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-0">Multi-Protocol</h5>
                      <p className="mb-0 text-muted">
                        Modbus, EtherCAT, Profinet
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div
                        className=" rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <i className="fa-solid fa-network-wired text-dark fs-4"></i>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-0">Protection Features</h5>
                      <p className="mb-0 text-muted">
                        Overcurrent, overheat, voltage
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Industry Applications Section */}
      <div className="container-fluid bg-light py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h6 className="fw-bold">INDUSTRY SOLUTIONS</h6>
            <h1 className="text-gradient-primary fs-2 fw-bold mt-1">
              Applications Across Industries
            </h1>
          </div>

          <div className="row g-4">
            {/* Packaging Industry */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-box text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">Packaging Industry</h4>
                  <p className="mb-4 fs-6">
                    Our automation solutions optimize packaging lines with
                    precise motion control, synchronized operations, and quick
                    changeovers for maximum efficiency.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Filling and sealing automation
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Labeling and marking systems
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Palletizing robots
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* CNC Machining */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-cogs text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">CNC Machining</h4>
                  <p className="mb-4 fs-6">
                    Xinje motion control technology provides the precision and
                    reliability required for modern CNC machines across
                    metalworking applications.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Multi-axis coordination
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Precision positioning systems
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Spindle speed control
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Robotics */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-robot text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">Robotics & Automation</h4>
                  <p className="mb-4 fs-6">
                    Our control systems power robotic applications with
                    synchronized motion control, real-time feedback, and
                    intelligent path planning.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Pick and place operations
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Assembly automation
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Material handling systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Textile Machinery */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-wind text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">Textile Machinery</h4>
                  <p className="mb-4 fs-6">
                    Xinje controllers manage complex textile processes with
                    tension control, pattern synchronization, and high-speed
                    operation capabilities.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Weaving machine control
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Printing pattern alignment
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Tension monitoring systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Food & Beverage */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-utensils text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">Food & Beverage</h4>
                  <p className="mb-4 fs-6">
                    Specialized hygiene-compliant automation solutions for food
                    processing, with focus on safety, traceability, and
                    production efficiency.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Mixing and batching systems
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Conveyor synchronization
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Temperature control loops
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Pharmaceutical */}
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 h-100 shadow-sm">
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-danger rounded-circle mb-4"
                    style={{ width: "70px", height: "70px" }}
                  >
                    <i className="fa-solid fa-pills text-white fs-3"></i>
                  </div>
                  <h4 className="mb-3">Pharmaceutical</h4>
                  <p className="mb-4 fs-6">
                    Precision control systems for pharmaceutical manufacturing
                    with validation features, audit trails, and cleanroom
                    compatibility.
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Blending and granulation
                    </li>
                    <li className="mb-2">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Tablet press automation
                    </li>
                    <li className="mb-0">
                      <i className="fa-solid fa-check text-danger me-2"></i>
                      Quality inspection systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Xinje;
